import { useCallback, useEffect } from 'react';
import { useLoadDataRequest } from '@futrli/shared-services';
import { fetchChartOfAccounts } from '../../../../core/api/financial-config';

type RequestDataType = Awaited<ReturnType<typeof fetchChartOfAccounts>>;

/**
 * Loads the chart of accounts for the given forecast ID
 * @param workspaceId - Workspace ID for the organisation
 * @param organisationId - Organisation ID
 * @param forecastId - Forecast ID
 */
export const useLoadChartOfAccounts = (workspaceId: string, organisationId: string, forecastId: string | undefined) => {
  const hasAllParams = !!workspaceId && !!organisationId && !!forecastId;
  const { load, ...rest } = useLoadDataRequest<RequestDataType>();

  const reload = useCallback(async () => {
    if (hasAllParams) {
      load(fetchChartOfAccounts(workspaceId, organisationId, forecastId));
    }
  }, [forecastId, hasAllParams, load, organisationId, workspaceId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    hasAllParams,
    reload,
    ...rest
  };
};
